// AddProject.tsx
import React from "react";
import { Button, Card, Group, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { usePostMultiplacerProjectAddProjectMutation } from "../openapi";

type FormValues = {
  projectNo: number | string;
  title: string;
  compCodePath: string;
  pnsPath: string;
  areaPath: string;
};

const AddProject: React.FC = () => {
  const [addProject, { isLoading, error, isSuccess }] =
    usePostMultiplacerProjectAddProjectMutation();

  const form = useForm<FormValues>({
    initialValues: {
      projectNo: "",
      title: "",
      compCodePath: "",
      pnsPath: "",
      areaPath: "",
    },
    validate: {
      projectNo: (v) => {
        const s = String(v ?? "").trim();
        const n = Number(s);
        if (!s) return "Påkrevd";
        if (!Number.isFinite(n)) return "Må være et tall";
        const len = s.length;
        return len === 6 || len === 8 ? null : "Må være 6 eller 8 sifre";
      },
      title: (v: string) => (v?.length >= 3 ? null : "Minst 3 tegn"),
      compCodePath: (v: string) => (v ? null : "Påkrevd"),
      pnsPath: (v: string) => (v ? null : "Påkrevd"),
      areaPath: (v: string) => (v ? null : "Påkrevd"),
    },
  });

  const handleSubmit = (values: FormValues) => {
    const payload = {
      project: {
        projectNo: Number(values.projectNo),
        title: values.title.trim(),
        compCodePath: values.compCodePath.trim(),
        pnsPath: values.pnsPath.trim(),
        areaPath: values.areaPath.trim(),
      },
    } as const;

    addProject({ body: payload });
  };

  return (
    <Card withBorder radius="lg" p="md">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <Group grow>
            <TextInput
              label="Prosjektnr"
              placeholder="10216575"
              {...form.getInputProps("projectNo")}
            />
            <TextInput
              label="Tittel"
              placeholder="Rikshospitalet"
              {...form.getInputProps("title")}
            />
          </Group>

          <Group grow>
            <TextInput
              label="Søkesti til compCode"
              placeholder="psets.NONS_Reference.RefCompType"
              {...form.getInputProps("compCodePath")}
            />
            <TextInput
              label="Søkesti til PNS"
              placeholder="psets.NRH_PG_Info.PNS"
              {...form.getInputProps("pnsPath")}
            />
            <TextInput
              label="Søkesti til area"
              placeholder="psets.Qto_SpaceBaseQuantities.NetFloorArea"
              {...form.getInputProps("areaPath")}
            />
          </Group>

          <Group justify="flex-end">
            <Button type="submit" loading={isLoading}>
              Legg til prosjekt
            </Button>
          </Group>
        </Stack>
      </form>
    </Card>
  );
};

export default AddProject;
